import React from 'react';
import styled from '@emotion/styled';
// import { css } from '@emotion/core';
import Container from './Container';
// import Logo from '../images/svgs/logo.svg';

const Footer = props => (
  <Wrapper {...props}>
    <Container>
      <div css={tw`mt-2 opacity-75 text-sm font-semibold`}>
        Copyright &copy; {new Date().getFullYear()} Erwan Muhibbain
      </div>
      <div css={[tw`mt-1 opacity-25 text-2xs font-medium`, { letterSpacing: 2 }]}>
        Developed by @wansaleh.
      </div>
    </Container>
  </Wrapper>
);

export default Footer;

const Wrapper = styled.footer`
  ${tw`p-10 text-center relative`}
  z-index: -1;
`;
